import getJobStatusColorClass from "@utils/getJobStatusColorClass"
import getJobStatusOrSubStatusLabel from "@utils/getJobStatusOrSubStatusLabel"

import { Skeleton } from "@particles/index"

import { StatusBadge } from "@molecules"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import { JobPreviewStatusBadgeProps } from "./JobPreviewStatusBadge.types"

export default function JobPreviewStatusBadge(props: JobPreviewStatusBadgeProps) {
    const { statusLabel, substatusLabel, startTime, statusColorOverride } = props
    const { isLoading } = useJobPreviewCard()

    if (isLoading && (!startTime || !statusLabel)) {
        return (
            <div>
                <Skeleton width={80} height={24} />
            </div>
        )
    }

    return (
        <StatusBadge
            status={getJobStatusOrSubStatusLabel({
                status_label: statusLabel,
                substatus_label: substatusLabel,
            } as Job)}
            dotStatusOverride={getJobStatusColorClass({
                status_color_override: statusColorOverride,
                status_label: statusLabel,
            } as Job)}
            dateDue={startTime ?? undefined}
        />
    )
}
